// extracted by mini-css-extract-plugin
export var copyableField = "_nz-4";
export var customerBadge = "_nz-0";
export var customerInfoTitle = "_nz-2";
export var details = "_nz-1";
export var dropdownContainer = "_nz-5";
export var dropdownImage = "_nz-6";
export var editAssigneeForm = "_nz-a";
export var editButton = "_nz-3";
export var email = "_nz-7";
export var hidden = "_nz-d";
export var input = "_nz-8";
export var saveButton = "_nz-b";
export var shopifyIcon = "_nz-c";
export var suggestionBadge = "_nz-e";
export var suggestionText = "_nz-f";
export var username = "_nz-9";